var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44155 18.3502C2.53836 18.7895 2.974 19.0335 3.36123 18.8871L13.8649 16.0565C14.2522 15.9589 14.4942 15.5196 14.3974 15.1292L11.9772 6.05168C11.8804 5.66124 11.4447 5.41723 11.0575 5.51483L7.33037 6.53971L8.49207 11.0297L5.53942 11.8593L4.32932 7.32058L0.553792 8.34546C0.166559 8.44306 -0.0754615 8.8823 0.0213468 9.32153L2.44155 18.3502ZM18.6085 0C17.7373 0 17.0596 0.732058 17.0596 1.56172V17.3742L0.263368 21.9617C0.0697509 22.0593 -0.0270573 22.2545 0.0213468 22.4498L0.602197 24.7435C0.699005 24.9388 0.892621 25.0364 1.08624 24.9876L20.1575 19.7656C20.2543 22.6938 22.6261 24.9876 25.5787 24.9876C28.5314 24.9876 31 22.5474 31 19.5215V0H18.6085ZM25.5787 21.8641C24.2718 21.8641 23.2553 20.8392 23.2553 19.5215C23.2553 18.2526 24.2718 17.179 25.5787 17.179C26.8372 17.179 27.9021 18.2526 27.9021 19.5215C27.9021 20.8392 26.8372 21.8641 25.5787 21.8641Z",
    fill: "#E6A151"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.ae4c215a9efdda0073d3d7377831d602.svg";
export { ForwardRef as ReactComponent };